import { render, staticRenderFns } from "./CompanyClientSelect.vue?vue&type=template&id=68a82e47&scoped=true&"
import script from "./CompanyClientSelect.vue?vue&type=script&lang=js&"
export * from "./CompanyClientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a82e47",
  null
  
)

export default component.exports